import cloneDeep from 'lodash/cloneDeep';
import omit from 'lodash/omit';
import * as actionTypes from '../action-types';
import { WatcherWithoutDocuments } from '../../watchers.types';
import { WatchersActions } from '../actions';

type Reducer = {
  [key: string]: WatcherWithoutDocuments['searchQueries'];
};

const defaultState: Reducer = {};

export function watchersQueriesMapReducer(
  state: Reducer = defaultState,
  action: WatchersActions,
) {
  switch (action.type) {
    case actionTypes.SET_WATCHERS: {
      const { watchers } = action.payload;
      return watchers.reduce(
        (
          acc: { [key: string]: WatcherWithoutDocuments['searchQueries'] },
          watcher,
        ) => {
          acc[watcher.key] = watcher.searchQueries;
          return acc;
        },
        {},
      );
    }
    case actionTypes.CREATE_WATCHER: {
      const { watcher } = action.payload;
      return { ...cloneDeep(state), [watcher.key]: watcher.searchQueries };
    }
    case actionTypes.DELETE_WATCHER: {
      const { watcherKey } = action.payload;
      return omit({ ...cloneDeep(state) }, watcherKey);
    }
    case actionTypes.SET_WATCHER: {
      const { watcher } = action.payload;
      return { ...cloneDeep(state), [watcher.key]: watcher.searchQueries };
    }

    case actionTypes.DELETE_WATCHER_QUERY: {
      const { watcherKey, type } = action.payload;
      return state[watcherKey]
        ? {
            ...cloneDeep(state),
            [watcherKey]: state[watcherKey].filter(
              searchQuery => searchQuery.type !== type,
            ),
          }
        : state;
    }
    default: {
      return state;
    }
  }
}
